export const parseEventMessage = (eventMessage: string) => {
  const [channelName, eventMessages] = JSON.parse(eventMessage);
  const messages = eventMessages.map((eventMessage: any) => {
    return JSON.parse(eventMessage[1].data);
  });
  return {
    channelName,
    messages
  };
};

export const getMessagesToRender = (toolMapping: any, accumulatedMessages: any[], newMessages: any[]) => {
  for (const message of newMessages) {
    if (message.type === "token") {
      if (
        accumulatedMessages.length === 0 ||
        typeof accumulatedMessages[accumulatedMessages.length - 1] !== "string"
      ) {
        accumulatedMessages.push(message.data);
      } else {
        accumulatedMessages[accumulatedMessages.length - 1] += message.data;
      }
    } else if (message.type === "tool_call") {
      const {
        tool_call_id,
        tool_title,
        content
      } = message.data;
      toolMapping[tool_call_id] = {
        type: "tool",
        tool_title,
        content,
        loading: true,
        index: accumulatedMessages.length
      };
      accumulatedMessages.push(toolMapping[tool_call_id]);
    } else if (message.type === "tool_result") {
      const {
        tool_call_id,
        tool_title,
        content,
        end
      } = message.data;
      if (end) {
        toolMapping[tool_call_id].loading = false;
      }
      if (tool_title) {
        toolMapping[tool_call_id].tool_title = tool_title;
      }
      toolMapping[tool_call_id].content += content;
      toolMapping[tool_call_id] = {...toolMapping[tool_call_id]};
      accumulatedMessages[toolMapping[tool_call_id].index] = toolMapping[tool_call_id];
    } else {
      accumulatedMessages.push(message); // system events
    }
  }
  return accumulatedMessages;
};
